var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.232 6.304l-2.744 3.664a.71.71 0 01-1.069.076L8 8.625",
    stroke: "#707175",
    strokeWidth: 1.502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.242 13.906H6.201a4.455 4.455 0 11-.597-8.89.317.317 0 00.292-.178 5.398 5.398 0 0110.479 1.27.343.343 0 00.241.28 3.81 3.81 0 01.214 7.36",
    stroke: "#707175",
    strokeWidth: 1.502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSaved;